var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('BBadge',{staticClass:"text-capitalize",attrs:{"pill":"","variant":_vm.result === 'success' ? 'success' : 'danger'}},[_vm._v(" "+_vm._s(_vm.result)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }